import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_service" },
  { title: "menu_sidebar_management_service_hospital" }
];

const HospitalManagementListing = Loadable({
  loader: () => import("container/management/hospital"),
  loading() {
    return <Loader />;
  }
});

export const hospitalRoutes: IRoute[] = [
  {
    path: "/management/hospital",
    element: <HospitalManagementListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
